import {Tag} from '../models/tag';
import {FilterNode, Filters} from '../models/filter';

export function facetSelectionsFromFilters(filters: Filters | null): Record<string, string> {
  const result: Record<string, string> = {};
  if (!filters?.tagFilters?.Filters) return result;
  for (const f of filters.tagFilters.Filters) {
    if ('Key' in f && f.Key === 'tag' && f.ID && f.Value) {
      result[f.ID] = f.Value.toUpperCase();
    }
  }
  return result;
}

export function facetSelectionsToFilterNodes(
  selections: Record<string, string>,
  knownTags: Tag[],
): FilterNode[] {
  return Object.entries(selections).map(([tagId, value]) => {
    const label = knownTags.find(t => t.ID === tagId)?.Label;
    return {Key: 'tag', ID: tagId, Value: value, Label: label} as FilterNode;
  });
}
